/* Gulabo Jaipur — bag shipping estimate.
   Display only. Shopify shipping profiles are what actually charge the customer,
   so the numbers in Theme settings > Shipping fees must match the rates in
   Settings > Shipping and delivery. */
(function () {
  var CFG = window.gulaboShipping;
  if (!CFG || !CFG.enabled) return;

  function inr(paise) {
    var n = Math.round((paise || 0) / 100);
    var s = String(n), last3 = s.slice(-3), rest = s.slice(0, -3);
    if (rest) last3 = ',' + last3;
    return '₹' + rest.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + last3;
  }

  function ladder(n) {
    if (n <= 0) return 0;
    if (n === 1) return CFG.first;
    return CFG.second + (n - 2) * CFG.extra;
  }

  /* Returns { fee, free, reason, remaining } for a cart object from /cart.js */
  function calculate(cart) {
    var units = [];
    (cart && cart.items ? cart.items : []).forEach(function (it) {
      var unit = typeof it.final_price === 'number' ? it.final_price : it.price;
      for (var i = 0; i < it.quantity; i++) units.push(unit);
    });
    if (!units.length) return { fee: 0, free: true, reason: 'empty' };

    var chargeable = units.filter(function (p) { return p < CFG.freeThreshold; });
    var premium = units.length - chargeable.length;

    if (CFG.freeWholeOrder && premium > 0) {
      return { fee: 0, free: true, reason: 'premium-item' };
    }
    if (!chargeable.length) {
      return { fee: 0, free: true, reason: 'all-above-threshold' };
    }

    var band = CFG.bandEnabled
      ? chargeable.filter(function (p) { return p >= CFG.bandMin && p <= CFG.bandMax; })
      : [];
    var other = chargeable.length - band.length;

    var fee;
    if (other === 0) fee = CFG.bandFee;
    else fee = ladder(other) + (band.length ? CFG.bandFee : 0);

    var out = { fee: fee, free: false, reason: 'charged', items: chargeable.length };
    if (CFG.freeWholeOrder) {
      var top = Math.max.apply(null, units);
      out.remaining = Math.max(0, CFG.freeThreshold - top);
    }
    return out;
  }

  function paint(cart) {
    var r = calculate(cart);
    var empty = !cart || !cart.items || !cart.items.length;

    document.querySelectorAll('[data-ship-row]').forEach(function (row) {
      row.hidden = empty;
      var val = row.querySelector('[data-ship-value]');
      if (val) val.textContent = r.free ? (CFG.freeLabel || 'Free') : inr(r.fee);
      row.classList.toggle('is-free', !!r.free);
    });

    document.querySelectorAll('[data-ship-total]').forEach(function (el) {
      var sub = cart && typeof cart.total_price === 'number' ? cart.total_price : 0;
      el.textContent = inr(sub + r.fee);
    });

    document.querySelectorAll('[data-ship-note]').forEach(function (el) {
      el.hidden = empty || r.free;
      if (CFG.note) el.textContent = CFG.note;
    });

    document.querySelectorAll('[data-ship-progress]').forEach(function (el) {
      var show = !empty && !r.free && r.remaining > 0 && CFG.progress;
      el.hidden = !show;
      if (show) el.textContent = CFG.progress.replace('[amount]', inr(r.remaining));
    });
  }

  function refresh() {
    return fetch((window.routes && window.routes.cart ? window.routes.cart : '/cart') + '.js', {
      headers: { 'Content-Type': 'application/json' }
    }).then(function (res) { return res.json(); })
      .then(paint)
      .catch(function () { });
  }

  /* Repaint whenever the theme redraws the bag.
     global.js rewrites #cartItems innerHTML on every cart change, so watching that
     element gives us the same signal without touching window.fetch — which GoKwik's
     bundle also uses. Nothing here intercepts requests or responses. */
  var pending;
  function scheduleRefresh() {
    clearTimeout(pending);
    pending = setTimeout(refresh, 80);
  }

  function watch() {
    if (!('MutationObserver' in window)) return;
    var items = document.getElementById('cartItems');
    if (!items) return;
    new MutationObserver(scheduleRefresh).observe(items, { childList: true, subtree: true });
  }

  function boot() { paint(CFG.cart); watch(); refresh(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.gulaboShippingCalc = calculate;
})();
